import { z } from 'zod';

/** 식별자 정규식 — C027 가드와 동일 */
const identifierRegex = /^[a-z_][a-z0-9_]*$/;

export const retentionPolicySchema = z
  .object({
    name: z
      .string()
      .min(1, '정책명은 필수입니다')
      .max(100, '100자 이하로 입력하세요')
      .regex(/^[a-zA-Z0-9_-]+$/, '영문·숫자·하이픈·밑줄만 허용됩니다'),
    description: z.string().max(512, '512자 이하로 입력하세요').optional(),
    targetTable: z
      .string()
      .min(1, '대상 테이블은 필수입니다')
      .max(128, '128자 이하로 입력하세요')
      .regex(identifierRegex, '소문자·숫자·밑줄만 허용됩니다 (예: biz_auditlog_audit_log)'),
    mode: z.enum(['SOFT_THEN_HARD', 'ABSOLUTE'], {
      required_error: '모드를 선택하세요',
    }),
    timeColumn: z
      .string()
      .min(1, '기준 시간 컬럼은 필수입니다')
      .max(64, '64자 이하로 입력하세요')
      .regex(identifierRegex, '소문자·숫자·밑줄만 허용됩니다 (예: created_at)'),
    retentionDays: z
      .number({ invalid_type_error: '숫자를 입력하세요' })
      .int('정수를 입력하세요')
      .min(0, '0 이상이어야 합니다')
      .nullable()
      .optional(),
    graceDays: z
      .number({ invalid_type_error: '숫자를 입력하세요' })
      .int('정수를 입력하세요')
      .min(0, '0 이상이어야 합니다')
      .nullable()
      .optional(),
    batchSize: z
      .number({ invalid_type_error: '숫자를 입력하세요' })
      .int('정수를 입력하세요')
      .min(1, '1 이상이어야 합니다')
      .max(100000, '100,000 이하로 입력하세요')
      .nullable()
      .optional(),
    enabled: z.boolean().default(false),
  })
  .superRefine((data, ctx) => {
    if (data.mode === 'ABSOLUTE' && (data.retentionDays == null || data.retentionDays === undefined)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['retentionDays'],
        message: 'ABSOLUTE 모드에서는 보존 기간(일)이 필수입니다',
      });
    }
    if (data.mode === 'SOFT_THEN_HARD' && (data.graceDays == null || data.graceDays === undefined)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ['graceDays'],
        message: '유예 후 삭제 모드에서는 유예 기간(일)이 필수입니다',
      });
    }
  });

export type RetentionPolicyFormValues = z.infer<typeof retentionPolicySchema>;

/** purge 확인 폼 스키마 */
export const purgeConfirmSchema = z.object({
  confirmName: z.string().min(1, '정책명을 입력하세요'),
});

export type PurgeConfirmValues = z.infer<typeof purgeConfirmSchema>;
